import type { Module } from 'vuex';
import { EmailTemplate } from '@/types/EmailTemplate';
import {RootState} from "@/store";

export interface EmailTemplateState {
  emailTemplate: EmailTemplate | null;
  deleted: boolean;
}

const emailTemplateModule: Module<EmailTemplateState, RootState> = {
  namespaced: true,
  state: (): EmailTemplateState => ({
    emailTemplate: null,
    deleted: false,
  }),
  mutations: {
    setEmailTemplate(state, payload: any) {
      if (payload === null) {
        state.emailTemplate = null;
        state.deleted = false;
        return;
      }
      state.emailTemplate = EmailTemplate.fromRaw(payload);
      state.deleted = false;
    },
    setEmailTemplateUpdate(state, payload: any) {
      if (!state.emailTemplate || state.emailTemplate.idEmailTemplate !== payload.idEmailTemplate) return;
      if (payload.name !== undefined) state.emailTemplate.name = payload.name;
      if (payload.orphan !== undefined) state.emailTemplate.orphan = payload.orphan;
    },
    setEmailTemplateDelete(state, payload: { idEmailTemplate: number }) {
      if (state.emailTemplate?.idEmailTemplate === payload.idEmailTemplate) {
        state.deleted = true;
      }
    },
    clearEmailTemplate(state) {
      state.emailTemplate = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetEmailTemplate({ commit }, payload) {
      commit('setEmailTemplate', payload);
    },
    wsSetEmptyEmailTemplate({ commit }) {
      commit('setEmailTemplate', null);
    },
    wsEmailTemplateUpdate({ commit }, payload) {
      commit('setEmailTemplateUpdate', payload);
    },
    wsEmailTemplateDelete({ commit }, payload) {
      commit('setEmailTemplateDelete', payload);
    },
    clearEmailTemplate({ commit }) {
      commit('clearEmailTemplate');
    },
  },
};

export default emailTemplateModule;
